import { SERVICES, FINANCING_PRODUCTS, FAQS } from "./content";
import { FIELD_CATEGORIES } from "./fieldServices";
import { HOME_FAQ, AREAS } from "./homeSite";
import { PP_COUNTIES } from "./preservation";
import { T as S8 } from "@/pages/Section8";

export const SITE_URL = "https://vertexhubventures.com";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;
const BRAND = "Vertexhub Ventures";

const PAGES = {
  "/": {
    title: "Home & Property Inspections in Doylestown, Harrisburg & Central PA | Vertexhub Ventures",
    description: "InterNACHI-certified home, investor, occupancy and construction draw inspections in Doylestown and Bucks County, the Harrisburg area and Central Pennsylvania. Photo reports within 24 hours.",
  },
  "/inspections": {
    title: "Inspection Services & Pricing in Pennsylvania | Vertexhub Ventures",
    description: "Home inspections from $399, pre-listing from $349, investor from $299, occupancy/field from $20, draw inspections from $150 and rental readiness walkthroughs from $199. Reports within 24 hours.",
  },
  "/service-areas": {
    title: "Service Areas: Bucks, Montgomery, Harrisburg & Central PA | Vertexhub Ventures",
    description: "Two offices, Doylestown and Coal Township, covering Bucks and Montgomery counties, Dauphin County and Central PA counties within about an hour of Coal Township.",
  },
  "/rehab-project-management": {
    title: "Rehab Project Management for PA Investors | Vertexhub Ventures",
    description: "Draw and paperwork management, full rehab management and rehab audits for Pennsylvania investors.",
  },
  "/privacy": { title: "Privacy Policy | Vertexhub Ventures", description: "Privacy policy of Vertexhub Ventures LLC." },
  "/terms": { title: "Terms | Vertexhub Ventures", description: "Terms of service of Vertexhub Ventures LLC." },
  "/packages": {
    title: "Auction Support Packages & Pricing | Vertexhub Ventures",
    description: "Clear pricing for Pennsylvania auction property support: pre-auction research, auction-day help, post-purchase coordination and possession packages for real estate investors.",
  },
  "/financing": {
    title: "Investor Financing in Pennsylvania: DSCR, Hard Money, Fix & Flip | Vertexhub Ventures",
    description: "Explore DSCR loans, hard money, fix and flip, bridge, rental and portfolio financing for Pennsylvania investment properties and auction purchases.",
  },
  "/counties": {
    title: "Pennsylvania Counties We Serve | Vertexhub Ventures",
    description: "Serving Northumberland, Columbia, Montour, Schuylkill, Snyder, Union, Dauphin, Luzerne and Lycoming counties in Pennsylvania.",
  },
  "/pa-auction-services/northumberland-county": {
    title: "Northumberland County PA Sheriff & Tax Sale Help | Vertexhub Ventures",
    description: "Local help buying Northumberland County, PA auction properties in Sunbury, Shamokin, Milton, Mount Carmel and more: research, inspections, possession and financing.",
  },
  "/field-services": {
    title: "Property Inspection & Field Services in Pennsylvania | Vertexhub Ventures",
    description: "Field inspection services PA: drive-by and vacant property inspections, mortgage field inspections, construction draw inspections, property preservation and merchant site verification.",
  },
  "/request-inspection": {
    title: "Request an Inspection or Get a Quote | Vertexhub Ventures",
    description: "Request a property inspection, field service or property preservation quote in Pennsylvania. Upload photos and documents and track your request online.",
  },
  "/property-inspections": {
    title: "Property Inspections in Central PA: Prices & Online Booking | Vertexhub Ventures",
    description: "Rental, investor, fix & flip, renovation progress and construction draw inspections from $125. 9+ years of experience. Instant estimate and online scheduling.",
  },
  "/property-inspections/book": {
    title: "Book a Property Inspection | Vertexhub Ventures",
    description: "Choose your inspection, get an itemized price and pick an available appointment time online.",
  },
  "/admin": { title: "Admin | Vertexhub Ventures", description: "Admin dashboard.", noindex: true },
  "/admin/login": { title: "Admin Sign In | Vertexhub Ventures", description: "Admin sign in.", noindex: true },
  "/how-it-works": {
    title: "How It Works: From Winning Bid to Possession | Vertexhub Ventures",
    description: "Step-by-step process for buying Pennsylvania auction properties: submit a property, research, auction day, post-purchase coordination and possession.",
  },
  "/about": {
    title: "About Kennedy, InterNACHI-Certified Inspector | Vertexhub Ventures",
    description: "Meet Kennedy, founder of Vertexhub Ventures LLC: InterNACHI-certified inspector with 9 years in Pennsylvania property preservation and mortgage field inspections. Woman-owned, bilingual.",
  },
  "/faq": {
    title: "FAQ: Inspections, Auctions & Investor Support in PA | Vertexhub Ventures",
    description: "Answers about Pennsylvania property inspections, auction support, possession, package fees and financing support through partner lenders.",
  },
  "/contact": {
    title: "Contact Vertexhub Ventures | (215) 445-4257",
    description: "Book an inspection or ask a question. Doylestown Office: 4387 W Swamp Rd, Suite 109, Doylestown, PA 18902. Coal Township Office: 421 S Poplar St, Suite 1, Coal Township, PA 17866.",
  },
  "/submit-property": {
    title: "Submit an Auction Property for Review | Vertexhub Ventures",
    description: "Send us a Pennsylvania auction property and get research, inspection and post-purchase support from a local team.",
  },
  "/request-financing": {
    title: "Request Investor Financing Review | Vertexhub Ventures",
    description: "Start a financing review for DSCR, hard money, fix and flip, bridge or rental property loans.",
  },
  "/wholesale": {
    title: "Submit a Wholesale Real Estate Deal | Vertexhub Ventures",
    description: "Wholesalers: submit your off-market property and get matched with active cash buyers and investors.",
  },
  "/buy": {
    title: "Find Investment Properties: Create Your Buy Box | Vertexhub Ventures",
    description: "Tell us what you want to buy and get matched with wholesale, auction and off-market investment properties.",
  },
  "/sell": {
    title: "Sell Your House to Investors | Vertexhub Ventures",
    description: "Property owners: share your property details and get options from our network of real estate investors.",
  },
  "/register-buy-box": {
    title: "Register Your Buy Box | Vertexhub Ventures",
    description: "Register your investment criteria (markets, price, property type) and receive matching deals.",
  },
  "/register-deal": {
    title: "Register Your Deal | Vertexhub Ventures",
    description: "Register a property deal to share with our buyer network of real estate investors.",
  },
  "/section8": {
    title: "Section 8 Investment Support | Vertexhub Ventures",
    description: "Property analysis, renovation coordination and Section 8 rental preparation for investors buying in Pennsylvania, with English and Portuguese support.",
  },
  "/client-login": { title: "Client Login | Vertexhub Ventures", description: "Vertexhub client portal login.", noindex: true },
  "/property-preservation": {
    title: "Property Preservation Services in Central PA | Vertexhub Ventures",
    description: "Full-service property preservation in Central Pennsylvania: securing, winterization, trash-outs, lawn & snow, evictions and REO services for banks, servicers, lenders and asset managers. Insured, background-checked, photo-documented.",
  },
  "/client-portal": { title: "Client Portal | Vertexhub Ventures", description: "Vertexhub client portal.", noindex: true },
};

const clip = (s) => (s.length > 158 ? `${s.slice(0, 155).trimEnd()}…` : s);

const faqSchema = (items) => ({
  "@type": "FAQPage",
  mainEntity: items.map(({ q, a }) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
});

const serviceSchema = (name, description, url) => ({
  "@type": "Service",
  name,
  description,
  url,
  provider: { "@id": `${SITE_URL}/#business` },
  areaServed: [{ "@type": "State", name: "Pennsylvania" }],
});

export function getSeo(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;
  const [, section, slug] = path.split("/");
  let page = PAGES[path];
  const schemas = [];

  if (!page && section === "services" && SERVICES[slug]) {
    const s = SERVICES[slug];
    page = { title: `${s.title} for Pennsylvania Auction Properties | ${BRAND}`, description: clip(s.intro) };
    schemas.push(serviceSchema(s.title, s.intro, url));
  }
  if (!page && section === "financing" && FINANCING_PRODUCTS[slug]) {
    const f = FINANCING_PRODUCTS[slug];
    page = { title: `${f.title} for Investors | ${BRAND}`, description: clip(f.intro) };
    schemas.push(serviceSchema(f.title, f.intro, url));
  }
  if (!page && section === "field-services" && slug === "service") {
    const name = (path.split("/")[3] || "").split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
    page = { title: `${name} in Pennsylvania | ${BRAND}`, description: `${name} by Vertexhub Ventures, a Pennsylvania real estate field services provider with 9+ years of experience. Request a quote online.` };
    schemas.push(serviceSchema(name, page.description, url));
  }
  const ar = AREAS.find((x) => x.slug === slug);
  if (!page && section === "service-areas" && ar) {
    page = { title: `${ar.title} | ${BRAND}`, description: clip(`${ar.intro} Reports within 24 hours.`) };
    schemas.push(serviceSchema(ar.title, ar.intro, url));
  }
  const fc = FIELD_CATEGORIES.find((c) => c.id === slug);
  if (!page && section === "field-services" && fc) {
    page = { title: `${fc.name} in Pennsylvania | ${BRAND}`, description: clip(fc.short + " " + fc.description) };
    schemas.push(serviceSchema(fc.name, fc.description, url));
  }
  if (!page) page = { ...PAGES["/"], noindex: true };

  if (path === "/faq") schemas.push(faqSchema(FAQS));
  if (path === "/property-preservation") {
    schemas.push({
      ...serviceSchema("Property Preservation Services", page.description, url),
      serviceType: "Property Preservation",
      provider: { "@type": "ProfessionalService", "@id": `${SITE_URL}/#business`, name: "Vertexhub Ventures LLC", telephone: "+1-215-445-4257" },
      areaServed: PP_COUNTIES.map((c) => ({ "@type": "AdministrativeArea", name: `${c} County, PA` })),
    });
  }
  if (path === "/") schemas.push(faqSchema(HOME_FAQ));
  if (path === "/section8") schemas.push(faqSchema(S8.en.faq.items));
  if (path !== "/") {
    schemas.push({
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
        { "@type": "ListItem", position: 2, name: page.title.split(" | ")[0], item: url },
      ],
    });
  }
  return { ...page, url, schemas };
}
